import { Component, Input, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { CommonActions } from 'src/app/common/store/actions/common.actions';
import { AppointmentDialogComponent } from '../appointment-dialog/appointment-dialog.component';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { MatDialog } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { BehaviorSubject, Observable } from 'rxjs';
import { FormBuilder } from '@angular/forms';
import { selectAllAppointments } from 'src/app/common/store/state/app.state';
import { AppFunctions } from '../../constants/app-functions';
import { AppointmentStatus } from '../../constants/common-basic-data';
import { ObjectSource } from '../../constants/general-basic-data';
import { Appointment } from '../../models/appointment.model';
import { ObjectData } from '../../models/object-data.model';
import { MatIconModule } from '@angular/material/icon';



@Component({
    selector: 'app-appointments',
    templateUrl: './appointments.component.html',
    styleUrls: ['./appointments.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatIconModule]
})
export class AppointmentsComponent {

  // @Input() appointments?: Appointment [] = [];
  // @Input() newAppointmentCarId: string = '';
  // @Input() newAppointmentCount: number = 0;

  @Input() objectSource: ObjectSource = ObjectSource.DEALER;
  @Input() offerId: string = "";
  @Input() enableNew: boolean = false;

  appointments$: Observable<Appointment[]>;
  appointments: Appointment[] = [];

  AppointmentStatus = AppointmentStatus;
  ObjectSource = ObjectSource

  openNewDialog$:BehaviorSubject<number>;

  todayDate: Date;
  tomorrowDate: Date;
  yesterdayDate: Date;


  constructor(
    private router: Router,
    public route: ActivatedRoute,
    private store: Store, 
    private readonly sanitizer: DomSanitizer,
    public dialog: MatDialog,
    private _formBuilder: FormBuilder) {

      this.todayDate = new Date();
      this.tomorrowDate = new Date(this.todayDate);
      this.yesterdayDate = new Date(this.todayDate);

      this.tomorrowDate.setDate(this.todayDate.getDate()+1);
      this.yesterdayDate.setDate(this.todayDate.getDate()-1);

      this.openNewDialog$ = new BehaviorSubject<number>(0);

      this.appointments$ = this.store.select(selectAllAppointments(this.objectSource, this.offerId))

    }
    
  ngOnInit(): void {

    this.appointments$ = this.store.select(selectAllAppointments(this.objectSource, this.offerId))
          
    this.appointments$.subscribe(
      (convs: Appointment[]) => this.appointments = convs
    );

  }

  ngOnChanges(changes: SimpleChanges): void {
    /*
    if(this.newAppointmentCount > 0){
      this.openAppointmentDialog(undefined)
    }
      */
    
  }

  openAppointmentDialog(appointmentId: number, isReschedule: boolean): void {

    //let appointmentId = (appointment == undefined) ? 0 : appointment.id;

    //console.log('index = '+JSON.parse(JSON.stringify(prop!)));
    let objectData: ObjectData = new ObjectData(this.objectSource, this.offerId, appointmentId );

    //console.log('prop = '+JSON.stringify(carId));
    const dialogRef = this.dialog.open(AppointmentDialogComponent, {
      data: objectData
    });

    if(isReschedule){
      let instance = dialogRef.componentInstance
      instance.isReschedule = isReschedule
    }
  }

/*

  openAppointmentDialogOld(prop?: Appointment): void {

    //console.log('index = '+JSON.parse(JSON.stringify(prop!)));
    let appointment: Appointment;

    if(prop !== undefined){
      appointment = JSON.parse(JSON.stringify(prop!));
      //console.log('hello 1')
    }else{
      appointment = new Appointment();
      appointment.carId = this.carId;
      //console.log('hello 2')
    }

    let isReschedule: boolean = (appointment.rescheduleDate === '1'); // 1 is to indicate that reschedule has to be edited

    //console.log('prop = '+JSON.stringify(carId));
    const dialogRef = this.dialog.open(AppointmentDialogComponent, {
      data: appointment
    });
    
    dialogRef.afterClosed().subscribe((result: Appointment) => {

      //console.log('helloo = '+JSON.stringify(result));
      if(result != undefined ){

        //console.log('New appointment = '+result.status+ " date = "+result.appointmentDate+ " car Id = "+JSON.stringify(result));
        if(result.id === 0){
          console.log('new')
          this.store.dispatch(CommonActions.appointmentNewSubmit ( { appointment: result, objectSource: this.objectSource }));
          return;
        }

        if(isReschedule){
          console.log('reschedule')
          this.store.dispatch(CommonActions.appointmentRescheduleSubmit ( { appointmentId: result.id, rescDate: result.rescheduleDate, objectSource: this.objectSource }));
          return;
        }

        else{
          console.log('update')
          this.store.dispatch(CommonActions.appointmentUpdateSubmit ( { appointment: result, objectSource: this.objectSource }));          
          return;
        } 
      }  
    });
  }
  */

  updateAppointmentStatus(appointmentId: number, status: AppointmentStatus){

    //console.log('heyy   '+status.toString());

    this.store.dispatch(CommonActions.appointmentStatusUpdateSubmit ( { appointmentId: appointmentId, status: status, objectSource: this.objectSource }));

  }

  onSelectedDatesChange(event: any){
    console.log('hellooo '+event.value);
    
  }

  filterPastDates = (date: Date): boolean => {

    if ( ! (date > this.yesterdayDate) ) {
      return false;
    } 

    return true;
  }

  moneyFormat(s: string): string{
    return AppFunctions.numberWithSpaces(s);
  }

  dateFormat(dt: string): string{

    return AppFunctions.stringToDatetime(dt);
  }

}
